import Marquee from "react-fast-marquee";

const ITEMS = [
  "JETDOG",
  "$JETDOG",
  "RIDE THE WAVE",
  "SOLANA SEND",
  "WET PAWS WET WINS",
  "GOOD BOY ENERGY",
  "1000X",
];

export const MarqueeBar = ({ variant = "yellow", direction = "left" }) => {
  return (
    <div
      className={`overflow-hidden ${variant === "yellow" ? "stripe-yellow" : "stripe-cyan"}`}
      data-testid={`marquee-${variant}`}
    >
      <Marquee gradient={false} speed={50} direction={direction} pauseOnHover>
        {Array.from({ length: 2 }).flatMap((_, i) =>
          ITEMS.map((t, j) => (
            <span
              key={`${i}-${j}`}
              className="gg-marquee-text text-3xl md:text-5xl uppercase mx-8 py-3 flex items-center gap-6"
            >
              {t}
              <span className="gg-marquee-sep text-2xl md:text-3xl">◆</span>
            </span>
          ))
        )}
      </Marquee>
    </div>
  );
};

export default MarqueeBar;
